import { useEffect, useState } from "react";
import { Sparkles, MapPin } from "lucide-react";
import { api } from "../lib/api";

export default function RecentJobBadge() {
    const [data, setData] = useState(null);

    useEffect(() => {
        api
            .get("/recent-activity")
            .then((r) => setData(r.data))
            .catch(() => {});
    }, []);

    if (!data) return null;
    const when =
        data.days_ago === 0
            ? "today"
            : data.days_ago === 1
              ? "yesterday"
              : `${data.days_ago} days ago`;

    return (
        <div
            className="inline-flex items-center gap-3 rounded-full border border-white/25 bg-white/10 backdrop-blur-md px-4 py-2 text-white text-sm"
            data-testid="recent-job-badge"
        >
            <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-secondary opacity-60" />
                <span className="relative inline-flex h-2 w-2 rounded-full bg-secondary" />
            </span>
            <Sparkles size={14} strokeWidth={1.75} className="text-secondary" />
            <span className="font-medium">
                Just quoted: <span className="text-secondary">{data.project_type}</span>
            </span>
            <span className="opacity-70 hidden sm:inline-flex items-center gap-1">
                <MapPin size={12} /> {data.location} · {when}
            </span>
        </div>
    );
}
